<template>
    <div>
        <confirm-box ref="error" :noConfirm="true"></confirm-box>
        <button 
            type="button" 
            class="btn btn-sm me-1" 
            :class="btnClass" 
            @click="toggle">
                <i class="fa-solid fa-ban"></i>
        </button>
    </div>
</template>

<script>
import ConfirmBox from './ConfirmBox';

export default {
    components: { ConfirmBox },

    props: {
        id: {
            type: Number,
            required: true,
        },

        value: {
            type: Number,
            default: 1,
        }
    },

    data() {
        return {
            status: this.value,
        };
    },

    computed: {
        btnClass: function() {
            return this.status === 0 ? 'btn-danger' : 'btn-secondary';
        }
    },

    methods: {
        toggle: function() {
            this.status = this.status > 0 ? 0 : 1;
            const data = { status: this.status };
            axios
                .patch(`/api/admin/users/update/${this.id}/status`, data)
                .then(response => {
                    this.status = response.data.status;
                    this.$emit('input', response.data.status);
                })
                .catch(error => {
                    if (error.response.status == 422) {
                        this.$refs.error.show({
                            title: 'User Update Error',
                            content: error.response.data.message,
                            callback: () => {},
                        });
                    } else {
                        console.error(error);
                        console.error(error.response);
                    }
                })
                .finally(() => {
                });
        },
    }
}
</script>